import AppsIcon from "@mui/icons-material/Apps";
import ErrorIcon from "@mui/icons-material/Error";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HistoryIcon from "@mui/icons-material/History";
import LinkIcon from "@mui/icons-material/Link";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PaymentsIcon from "@mui/icons-material/Payments";
import PeopleIcon from "@mui/icons-material/People";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Admin, Resource } from "react-admin";
import { Dashboard } from "@/components/Dashboard";
import { AdminLayout } from "@/components/Layout";
import { LoginPage } from "@/components/LoginPage";
import { authProvider } from "@/providers/authProvider";
import { dataProvider } from "@/providers/dataProvider";

// Resources
import { AppCreate, AppEdit, AppList, AppShow } from "@/resources/apps";
import { AuditLogList } from "@/resources/audit-logs";
import { DeadLetterEventList } from "@/resources/dead-letter-events";
import {
	PartnerEarningCreate,
	PartnerEarningEdit,
	PartnerEarningList,
	PartnerEarningShow,
} from "@/resources/partner-earnings";
import {
	PartnerPayoutCreate,
	PartnerPayoutEdit,
	PartnerPayoutList,
	PartnerPayoutShow,
} from "@/resources/partner-payouts";
import {
	PartnerCreate,
	PartnerEdit,
	PartnerList,
	PartnerShow,
} from "@/resources/partners";
import { PurchaseEventList } from "@/resources/purchase-events";
import {
	ReferralLinkCreate,
	ReferralLinkEdit,
	ReferralLinkList,
	ReferralLinkShow,
} from "@/resources/referral-links";
import { UserEdit, UserList, UserShow } from "@/resources/users";

export const App = () => (
	<Admin
		authProvider={authProvider}
		dataProvider={dataProvider}
		dashboard={Dashboard}
		loginPage={LoginPage}
		layout={AdminLayout}
		requireAuth
	>
		<Resource
			name="apps"
			list={AppList}
			edit={AppEdit}
			create={AppCreate}
			show={AppShow}
			recordRepresentation="name"
			icon={AppsIcon}
		/>
		<Resource
			name="partners"
			list={PartnerList}
			edit={PartnerEdit}
			create={PartnerCreate}
			show={PartnerShow}
			recordRepresentation="name"
			icon={HandshakeIcon}
		/>
		<Resource
			name="referral-links"
			list={ReferralLinkList}
			edit={ReferralLinkEdit}
			create={ReferralLinkCreate}
			show={ReferralLinkShow}
			recordRepresentation="code"
			options={{ label: "Referral Links" }}
			icon={LinkIcon}
		/>
		<Resource
			name="users"
			list={UserList}
			edit={UserEdit}
			show={UserShow}
			recordRepresentation="email"
			icon={PeopleIcon}
		/>
		<Resource
			name="audit-logs"
			list={AuditLogList}
			options={{ label: "Audit Logs" }}
			icon={HistoryIcon}
		/>
		<Resource
			name="purchase-events"
			list={PurchaseEventList}
			options={{ label: "Purchase Events" }}
			icon={ShoppingCartIcon}
		/>
		<Resource
			name="dead-letter-events"
			list={DeadLetterEventList}
			options={{ label: "Dead Letter Events" }}
			icon={ErrorIcon}
		/>
		<Resource
			name="partner-earnings"
			list={PartnerEarningList}
			edit={PartnerEarningEdit}
			create={PartnerEarningCreate}
			show={PartnerEarningShow}
			options={{ label: "Partner Earnings" }}
			icon={MonetizationOnIcon}
		/>
		<Resource
			name="partner-payouts"
			list={PartnerPayoutList}
			edit={PartnerPayoutEdit}
			create={PartnerPayoutCreate}
			show={PartnerPayoutShow}
			options={{ label: "Partner Payouts" }}
			icon={PaymentsIcon}
		/>
	</Admin>
);
